import { render, staticRenderFns } from "./BorderPicker.vue?vue&type=template&id=23bfcc20&scoped=true"
import script from "./BorderPicker.vue?vue&type=script&lang=js"
export * from "./BorderPicker.vue?vue&type=script&lang=js"
import style0 from "./BorderPicker.vue?vue&type=style&index=0&id=23bfcc20&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23bfcc20",
  null
  
)

export default component.exports